// in px
export const CARD_WIDTH = 360;
export const CARD_GAP = 16;
